"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadForm = exports.LOAD_FORM_SUCCESS = exports.LOAD_FORM_ERROR = exports.LOAD_FORM = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = _interopRequireDefault(require("../../config/utils"));

var LOAD_FORM = exports.LOAD_FORM = 'LOAD_FORM';
var LOAD_FORM_SUCCESS = exports.LOAD_FORM_SUCCESS = 'LOAD_FORM_SUCCESS';
var LOAD_FORM_ERROR = exports.LOAD_FORM_ERROR = 'LOAD_FORM_ERROR';

if (!window.pdfFormConfigObject) {
  (0, _utils["default"])();
}

var apiUrl = window.pdfFormConfigObject.api_url;
var xcrsf = window.pdfFormConfigObject.csrf;
var environment = window.pdfFormConfigObject.environment;
var PRODUCTION_HEADERS = {
  'X-CSRF-Token': xcrsf,
  'x-requested-with': 'XMLHttpRequest',
  accept: 'application/json, text/javascript, */*; q=0.01',
  'content-type': 'application/json'
};
var DEVELOPMENT_HEADERS = {
  'X-User-Email': 'pernix@careerplug.com',
  'X-User-Token': '1QiZ8aGJibRcZRqbspT4',
  'x-requested-with': 'XMLHttpRequest',
  accept: 'application/json, text/javascript, */*; q=0.01',
  'content-type': 'application/json'
};

var loadForm = exports.loadForm = function loadForm(formURL) {
  var fetchStart = function fetchStart() {
    return {
      type: LOAD_FORM,
      payload: true
    };
  };

  var fetchSuccess = function fetchSuccess(form) {
    return {
      type: LOAD_FORM_SUCCESS,
      payload: form
    };
  };

  var fetchError = function fetchError(errorMsg) {
    return {
      type: LOAD_FORM_ERROR,
      payload: errorMsg
    };
  };

  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(dispatch) {
        var response, data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch(fetchStart());
                _context.prev = 1;
                _context.next = 4;
                return fetch("" + apiUrl + formURL, {
                  method: 'GET',
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;
                dispatch(fetchSuccess(data));
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                dispatch(fetchError(_context.t0));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};